import React, { useRef } from 'react';
var VeltNotificationsPanelTitleText = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-title-text", { ref: ref }, children));
};
export default VeltNotificationsPanelTitleText;
